class ProductPrice extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        (this.compare_price = this.querySelector(".product-price--compare")),
            (this.price = this.querySelector(".product-price--original")),
            (this.reference_unit = this.querySelector(".product-price--reference-unit")),
            (this.reference_value = this.querySelector(".product-price--reference-value")),
            (this.unit_price = this.querySelector(".product-price--unit-price")),
            (this.unit_price_container = this.querySelector(".product-price--unit-container")),
            (this.sale_label = this.querySelector(".product--label_sale_percent")),
            this.updatePriceListener();
    }
    disconnectedCallback() {
        window.off(`theme:product:${this.dataset.id}:variantChanged.ProductPrice`);
    }
    updatePriceListener() {
        window.on(`theme:product:${this.dataset.id}:variantChanged.ProductPrice`, ({ detail: { variant: e } }) => {
            this.updatePrices(e);
        });
    }
    updatePrices(e) {
        e
            ? (this.removeAttribute("style"),
              (this.price.innerHTML = theme.utils.formatMoney(e.price)),
              e.compare_at_price > e.price ? ((this.compare_price.innerHTML = theme.utils.formatMoney(e.compare_at_price)), (this.compare_price.style.display = "inline-block")) : (this.compare_price.style.display = "none"),
              e.unit_price_measurement
                  ? ((this.unit_price.innerHTML = theme.utils.formatMoney(e.unit_price)),
                    (this.reference_unit.innerHTML = e.unit_price_measurement.reference_unit),
                    1 === e.unit_price_measurement.reference_value && this.reference_value
                        ? (this.reference_value.style.display = "none")
                        : this.reference_value && ((this.reference_value.innerHTML = e.unit_price_measurement.reference_value), (this.reference_value.style.display = "block")),
                    (this.unit_price_container.style.display = "flex"))
                  : (this.unit_price_container.style.display = "none"))
            : (this.style.display = "none");
      
      // bbb pdp sale X% OFF badge - begin
      const fullTitle = e.title;
const titleParts = fullTitle.split(" / ");
const shortTitle = titleParts[1]; // A doua parte
      
const allSwatchButtons = document.querySelectorAll('.radios--swatch-button');
allSwatchButtons.forEach(button => {
  button.classList.remove('show_badge');
});
      
const swatchButton = document.querySelector(`.radios--swatch-button[aria-label="${shortTitle}"]`);

      console.log(e);
      
      if (e.compare_at_price > e.price) {
        // const discountPercentage = Math.floor(((e.compare_at_price - e.price) / e.compare_at_price) * 100);
        // console.log(e.title);
        
        const priceDiff = e.compare_at_price - e.price;
        let percentDiff = (priceDiff / e.compare_at_price) * 100;

        const decimalPart = percentDiff - Math.floor(percentDiff);  // Extract the decimal part

        // Apply the rounding logic based on the decimal part
        if (decimalPart < 0.8) {
            percentDiff = Math.floor(percentDiff);  // Round down if the decimal part is less than 0.8
        } else {
            percentDiff = Math.round(percentDiff);   // Round up if the decimal part is greater than or equal to 0.8
        }

        if (this.sale_label) {
            this.sale_label.innerHTML = `${percentDiff}% OFF`;
            this.sale_label.style.display = "inline-block";
            // swatchButton.classList.remove("hide_badge");

        }
      }else{
        if (this.sale_label) {
            this.sale_label.style.display = "none";
          // swatchButton.classList.add("hide_badge");
        }
      }// bbb - end
    }
}
const productPriceEl = customElements.get("product-price-root");
productPriceEl || customElements.define("product-price-root", ProductPrice);
